/**
 * Gestisce la paginazione e l'ordinamento dei risultati di ricerca
 */
export class SearchPagination {
    
    /**
     * Inizializza gli event listener per la paginazione
     */
    public init(): void {
        $("a#prevpage").on('click', (e) => {
            e.preventDefault();
            this.updatePage(-1);
        });

        $("a#nextpage").on('click', (e) => {
            e.preventDefault();
            this.updatePage(1);
        });

        $("ul.pagination > li.pagebuttoncsshandler").on('click', (e) => {
            e.preventDefault();
            const newpage = parseInt($(e.currentTarget).attr("class") || '1');
            this.reloadResults(newpage, null);
        });
    }

    /**
     * Inizializza il bottone per l'ordinamento
     */
    public initSortButton(): void {
        const orderButton = document.getElementById('btnOrderType');
        if (!orderButton) return;

        orderButton.addEventListener('click', async () => {
            const innerSpan = orderButton.querySelector('span.material-symbols-outlined');
            if (!innerSpan) return;

            const currentText = innerSpan.textContent;
            if (currentText === 'arrow_upward_alt') {
                innerSpan.textContent = 'arrow_downward_alt';
                await this.reloadResults(1, 'Desc');
            } else {
                innerSpan.textContent = 'arrow_upward_alt';
                await this.reloadResults(1, 'Asc');
            }
        });
    }

    /**
     * Ricarica i risultati con nuova paginazione/ordinamento
     */
    public async reloadResults(pageNumber: number | null = null, orderType: string | null = null): Promise<void> {
        const form = document.getElementById('frmDetail');
        if (!form) return;

        const pageNumberField = form.querySelector('[name="PageData.CurrentPage"]') as HTMLInputElement;
        const orderField = form.querySelector('[name="PageData.OrderField"]') as HTMLInputElement;
        const orderTypeField = form.querySelector('[name="PageData.OrderType"]') as HTMLInputElement;

        if (pageNumberField) pageNumberField.value = pageNumber !== null ? pageNumber.toString() : pageNumberField.value;
        if (orderField) orderField.value = "Price";
        if (orderTypeField) orderTypeField.value = orderType !== null ? orderType : orderTypeField.value;

        const formData = new FormData(form as HTMLFormElement);
        const serializedData = new URLSearchParams(formData as any).toString();

        const baseUrl = this.getFullDomain();
        const fullUrl = `${baseUrl}/Search/DetailAjax`;

        $("#loading2").show();
        try {
            const response = await fetch(fullUrl, {
                method: 'POST',
                body: serializedData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });

            if (!response.ok) {
                throw new Error(`Errore nella richiesta: ${response.statusText}`);
            }

            const data = await response.text();
            const detailDiv = document.querySelector('div#DetailSearch');
            if (detailDiv) {
                detailDiv.innerHTML = data;
                detailDiv.scrollIntoView({ behavior: 'smooth' });
                this.refreshLazyLoad();
            }
        } catch (error) {
            console.error('Errore nella richiesta:', error);
        } finally {
            $("#loading2").hide();
            this.init(); // Re-inizializza gli eventi dopo il reload
        }
    }

    // ====== METODI PRIVATI ======

    private updatePage(increment: number): void {
        const page = parseInt($("input[name='PageData.CurrentPage']").val() as string || '1');
        const newpage = page + increment;
        this.reloadResults(newpage, null);
    }

    /**
     * Notifica a vanilla-lazyload i nuovi elementi ".lazy" inseriti nel DOM
     * dopo la sostituzione via DetailAjax, altrimenti le immagini non vengono più osservate.
     */
    private refreshLazyLoad(): void {
        const lazyLoadInstance = (window as any).lazyLoadInstance;
        if (lazyLoadInstance && typeof lazyLoadInstance.update === 'function') {
            lazyLoadInstance.update();
        }
    }

    private getFullDomain(): string {
        return window.location.protocol + "//" + window.location.host;
    }
}
